import { render, staticRenderFns } from "./AdvisorCard.vue?vue&type=template&id=7ace5a74"
import script from "./AdvisorCard.vue?vue&type=script&lang=js"
export * from "./AdvisorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports